// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"a94721e3","787":"2080ffd6","880":"202fcf7e"}[chunkId] + ".chunk.js";
};